import axios from 'axios';

axios.defaults.baseURL = import.meta.env.VITE_BASE_API_URL;

export * from 'axios';

export default axios;
